import { setFilter } from "../tradeReviewUXSlice";
import { setData } from "../tradeReviewDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import React from "react";
import { TradeReviewReportFilter } from "../types";
import { useCopiedState } from "../../../../../core/util/hooks";

export const useTradeReviewReportFilter = () => {
  const storeFilter = useSelector<StoreType, TradeReviewReportFilter>(
    (store) => store.ux.reports.exchbusiness.tradeReview.filter
  );
  const [filter, editFilter] = useCopiedState<TradeReviewReportFilter>(
    storeFilter
  );

  const dispatch = useDispatch();
  const dispatchSetFilter = React.useCallback(() => {
    dispatch(setFilter(filter!));
    dispatch(setData());
  }, [dispatch, filter]);

  return [filter, editFilter, dispatchSetFilter] as [
    typeof filter,
    typeof editFilter,
    typeof dispatchSetFilter
  ];
};
